import '@/web-components/web-core.scss';
import 'reflect-metadata';
import { createApp } from 'vue';
import { createHead } from '@unhead/vue';
import VlUiVueComponents from '@govflanders/vl-ui-design-system-vue3';
import pinia from './infrastructure/store';
import gtag from './infrastructure/gtag';
import router from './infrastructure/router';
import App from './modules/app.vue';
import DlComponents from './infrastructure/dl-components';
import { LocalVue3WebComponentsPlugin } from './web-components';
import { setValidationLocale } from './infrastructure/locales/validation';
import { registerOlProjections } from './infrastructure/ol/ol.utils';

const app = createApp(App);
const head = createHead();

registerOlProjections();

app.use(head);
app.use(router);
app.use(VlUiVueComponents);
app.use(DlComponents);
app.use(LocalVue3WebComponentsPlugin);
app.use(pinia);
app.use(gtag);

app.mount('#app');

setValidationLocale();

export default app;
